module.exports = __webpack_public_path__ + "img/dash-card-icon-1.0c96cce8.svg";